import React, {useEffect, useRef, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import FileUpload from "../../../FileUploads/FileUpload";
import SuccessModal from "../../../CustomModal/Success";
import {toast} from "react-toastify";
import DashboardMenu from "../../../layout/dashboardMenu";
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import Type from "./Type";
import useCurrentlocation from "../../../../hooks/currentlocation/useCurrentlocation";
import {generateRandomString, versionCheck} from "../../../Common";
import distanceBetweenTwoPoints from "../../../DistanceBetweenTwoPoints";
import DistanceCalculatorV2 from "../../../DistanceCalculatorV2";
import { APARTMENT_CHECK_IN_URL, APARTMENT_CHECK_OUT_URL, isNewLeadX } from '../../../../utils/redirection';

const V2OpportunityActivity = ({
                                   dropdownData,
                                   dropdownValue = [],
                                   match,
                                   getV2OpportunityActivities,
                                   leadOpportunityActivity = [],
                                   history,
                                   documentUploadUrlPublic,
                                   documentUrlDataPublic,
                                   saveActivity,
                                   saveActivityRes = [],
                                   getLastLeadOpportunityActivities,
                                   LastLeadOpportunityActivity = [],
                                   markAttendance,
                                   attendance,
                                   isUserCheckInForModule,
                                   userCheckInForModule = [],
                                   accountDetailsById,
                                   accountDetails = [],
                                   getOpportunity,
                                   opportunityDetails=[],
                                   getSenior,
                                   senior=[],
                                   getSelectedTaggedAlong,
                                   selectedTaggedAlongResponse=[],
                                   errorLogs
                               }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [inputList, setInputList] = useState([{
        future_activity_date: '',
        meta_data: {},
        lat: '',
        long: '',
        kdm_details: '',
        opportunity_id: '',
        lead_id: '',
        sub_stage_id: '',
        kdm: '',
        poc: '',
        delete_kdm_ids:[],
        delete_poc_ids:[]
    }])
    const currentUserLocation = useRef(null);
    const [successMessage, setSuccessMessage] = useState('')
    const [backUrl, setBackUrl] = useState('')
    const [activityId, setActivityId] = useState(0)
    const [stageId, setStageId] = useState('')
    const [openCheckIn, setOpenCheckIn] = useState(false)
    const [checkInText, setCheckInText] = useState('Check In')
    const [projectName, setProjectName] = useState('')
    const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({})
    const [projectType, setProjectType] = useState(0)
    const [isMockLocation, setIsMockLocation] = useState(false)
    const [hideCheckIn, setHideCheckIn] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false)
    const currentLocation = useCurrentlocation();
    const [isLocationFetching, setIsLocationFetching] = useState(false);
    const [locationStatus, setLocationStatus] = useState(null)

    useEffect( async () => {
        const webView = window.localStorage?.webview;
        if(versionCheck('3.0.0')){
            if(webView !== undefined && webView == 'true') {
                setIsLocationFetching(true);
                getUserLocation();
            } else {
                setIsLoading(true);
                setLocationStatus('granted');
                currentUserLocation.current = await getLocation();
                console.log("currentUserLocation.current", currentUserLocation.current)
                setIsLocationFetching(false);
                setIsLoading(false)
            }
        }
    }, []);

    function locationCallback(data) {
        if (data.detail) {
            if (data?.detail?.gps_status === "granted") {
                if (data.detail.status === "granted") {
                    setLocationStatus("granted");
                    currentUserLocation.current = {
                        lat: data?.detail?.latitude,
                        long: data?.detail?.longitude,
                        is_mock: data.detail.mocked,
                        device_id: data.detail.device_id
                    }
                } else {
                    setLocationStatus("permission_denied");
                }
            } else {
                setLocationStatus("gps_denied");
            }
        }
        setIsLocationFetching(false);
    }

    const getUserLocation = () => {
        let eventName = `locationEvent${generateRandomString()}`;
        window.addEventListener(eventName, locationCallback)
        window.ReactNativeWebView.postMessage(JSON.stringify({
            event_name: "get_current_location",
            data: {
                accuracy: 4,
                callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
            }
        }));
        return () => {
            window.removeEventListener(eventName, locationCallback)
        }
    }

    function getLocation() {

        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
                    if (permissionStatus.state === 'denied') {
                        alert('Please allow location access.');
                        setIsLoading(false);
                        reject('Location access denied.');
                        setIsLocationFetching(false);
                    } else {
                        setLocationStatus('granted')
                        navigator.geolocation.getCurrentPosition(
                            (success) => {
                                if (success?.coords && success.coords.latitude) {
                                    const location = {
                                        lat: success.coords.latitude,
                                        long: success.coords.longitude,
                                        is_mock: false,
                                        device_id: ''
                                    };
                                    setIsLoading(false);
                                    resolve(location);
                                }
                            },
                            (error) => {
                                setIsLoading(false);
                                reject(error);
                            }
                        );
                    }
                }).catch(err => {
                    setIsLoading(false);
                    reject(err);
                });
            } else {
                setIsLoading(false);
                reject('Geolocation not supported.');
            }
        });
        setIsLoading(false);
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getLastLeadOpportunityActivities(match?.params?.opportunity_id, match?.params?.account_id)
            await getSelectedTaggedAlong(match?.params?.account_id, match?.params?.opportunity_id)
            await getOpportunity(match?.params?.opportunity_id, match?.params?.account_id)
            await accountDetailsById(match?.params?.account_id)
            await getSenior()
            setIsLoading(false)
        })()
    }, [])


    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);


    useEffect(() => {
        let oppType = 'is_apartment'
        let projectType = 2;
        if (Object.keys(accountDetails).length > 0 && accountDetails?.project_name !== undefined) {
            if (accountDetails?.project_name === "Corporate") {
                oppType = 'is_corporate'
                projectType = 1;
            } else if (accountDetails?.project_name !== "Society") {
                oppType = 'is_supply'
                projectType = 1;
            }


            (async () => {
                setProjectType(projectType)
                let project = accountDetails?.project_name === "Public Parking" ? "Parking" : accountDetails?.project_name
                setProjectName(project)
                await isUserCheckInForModule(project, match?.params?.account_id, 'account_id', true)
                await dropdownData(oppType)
                await getV2OpportunityActivities(projectType, match?.params?.opportunity_id)
            })()
        }
    }, [accountDetails])

    const handleInput = (key, val, metaKey = '', e = '') => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                // inputList[0][key][metaKey] = e.target.selectedOptions[0].text
                inputList[0][key][metaKey + "_id"] = val
                if (typeof val === 'string' || val instanceof String) {
                    inputList[0][key][metaKey] = val
                }
            } else if (metaKey !== '') {
                inputList[0][key][metaKey] = val
            } else {
                inputList[0][key] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        if (userCheckInForModule === null) {
            if(isNewLeadX()){
                window.location.replace(APARTMENT_CHECK_IN_URL+`?account_id=${match?.params?.account_id}%26opportunity_id=${match?.params?.opportunity_id}%26lead_id=${match?.params?.lead_id}%26redirect_to=${window.location.href}`)
            } else {
                setCheckInText("Check In")
                setOpenCheckIn(true)
            }
        } else if(userCheckInForModule?.opportunity_id !== undefined && parseInt(userCheckInForModule?.opportunity_id) !== parseInt(match?.params?.opportunity_id)){
            toast.warning(`You have not checked out from your last check-in ${userCheckInForModule?.client_name} (${userCheckInForModule?.account_id}). Please check out first before you do a new check-in.`);

            setTimeout(() => {
                if(isNewLeadX()){
                    window.location.replace(APARTMENT_CHECK_OUT_URL+`?id=${userCheckInForModule?.id}%26account_id=${match?.params?.account_id}%26opportunity_id=${match?.params?.opportunity_id}%26lead_id=${match?.params?.lead_id}`)
                } else {
                    window.location.href = match?.params?.lead_id !== undefined ? `v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}/${match?.params?.lead_id}` :`v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`
                }
            }, 2000)
        }
    }, [userCheckInForModule])

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveActivityRes?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(saveActivityRes?.message)
            toast.success("Activity is completed.")
            // setTimeout(() => {
            //     window.location.href = match?.params?.lead_id !== undefined ? `v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}/${match?.params?.lead_id}` :`v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`
            // }, 1000)
            setOpenCheckIn(true)
            if(isNewLeadX()){
                window.location.replace(APARTMENT_CHECK_OUT_URL+`?id=${userCheckInForModule?.id}%26account_id=${match?.params?.account_id}%26opportunity_id=${match?.params?.opportunity_id}%26lead_id=${match?.params?.lead_id}`)
            } else {
                setCheckInText("Check out")
            }
        } else if (saveActivityRes?.status !== undefined && saveActivityRes?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(saveActivityRes?.message)
        }
    }, [saveActivityRes])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        list['next_activity_type_id'] = activityId
        if(!versionCheck('3.0.0')) {
            list['lat'] = islatlng?.lat
            list['long'] = islatlng?.lng
        } else {
            list['lat'] = currentUserLocation?.current?.lat
            list['long'] = currentUserLocation?.current?.long
        }
        list['status'] = 2
        list['is_attendance_need_to_check'] = true
        list['closure_date'] = new Date();
        list['version_type'] = "V2";
        list['module_type'] = projectName;
        list['check_sequence'] = true;
        list['check_pending_meeting_globally'] = true;
        list['check_empty_activity_id'] = true;
        list['business_creation'] = true;
        if(taggedAlonedReportee.length > 0){
            list['tag_along'] = taggedAlonedReportee.map(value => value.id);
        }
        // module_name is column name of lsq_activity_types to check this activity type is active or not
        list['module_name'] = 'is_opportunity'

        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }
        list['account_id'] = match?.params?.account_id
        list['opportunity_id'] = match?.params?.opportunity_id
        if(match?.params?.lead_id !== undefined){
            list['lead_id'] = match?.params?.lead_id
        }


        list['is_opportunity_close'] = parseInt(activityId) === 35 || parseInt(activityId) === 39
        list['is_opportunity_dropped'] = parseInt(activityId) === 41 || parseInt(activityId) === 42
        // if (list?.meta_data?.MOM !== undefined && list?.meta_data?.MOM.split(" ").length < 70) {
        //     toast.warning("MOM must be minimum 30 words")
        //     return false
        // }
        if (list?.meta_data?.MOM !== undefined && list?.meta_data?.MOM.length < 70) {
            toast.warning("MOM must be minimum 70 characters");
            return false;
        }
        
        // console.log("listlistlistlist "+JSON.stringify(list))
        // return false

        setIsLoading(true)
        await saveActivity(list)
        setIsLoading(false)
    }

    useEffect(() => {
        if (parseInt(attendance?.status) === 200) {
            toast.success("Check In is marked successfully")
            window.location.href = match?.params?.lead_id !== undefined ? `v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}/${match?.params?.lead_id}` :`v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`
        } else if (parseInt(attendance?.status) !== 200){
            toast.warning(attendance?.message)
        }
    }, [attendance])

    useEffect(() => {
        if(versionCheck('3.0.0')){
            if(currentUserLocation?.current?.is_mock){
                setIsMockLocation(true)
            }
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)
        }
    }, [currentUserLocation?.current?.lat])

    useEffect(() => {
        if(!versionCheck('3.0.0')) {
            if(currentLocation?.is_mock){
                setIsMockLocation(true)
            }
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 1000)
        }
    }, [currentLocation])

    const handleResetMetaData = () => {
        // inputList[0]['meta_data'] = {}
        // setInputList(inputList)
    }

    useEffect(() => {
        if(isMockLocation){
            setOpenCheckIn(false)
            setHideCheckIn(true)
            setDisableSubmit(true)
            setIsMockLocation(true)
            // toast.error('Location morphing is cheating. Check in not allowed');
            handleErrorLogsSave(`Location morphing is cheating. ${checkInText} not allowed`, checkInText);
            setCountToOpenModal(countToOpenModal+1);
        }
    }, [isMockLocation])

    const handleErrorLogsSave = async (msg, type) => {
        setOpenCheckIn(false)
        setIsLoading(true)
        await errorLogs({
            module_type:accountDetails?.project_name,
            message: msg,
            type: type,
            device_id: window.localStorage.device_id ?? null
        });
        setIsLoading(false)
    }

    const refreshUserLocation = async (e) => {
        e.preventDefault();
        const webView = window.localStorage?.webview;
        if(webView !== undefined && webView == 'true') {
            setIsLocationFetching(true);
            getUserLocation();
        } else {
            setIsLoading(true);
            setIsLocationFetching(true);
            currentUserLocation.current = await getLocation();
            setIsLocationFetching(false);
            setIsLoading(false);
        }
    }

    return (
        <>
            {/*<SuccessModal*/}
            {/*    isOpen={isSuccessModalOpen}*/}
            {/*    msg={successMessage}*/}
            {/*    url={match?.params?.lead_id !== undefined ? `v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}/${match?.params?.lead_id}` :`v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}*/}
            {/*/>*/}

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
                url={backUrl}
            />
            {isMockLocation &&
                <FailedModal
                    isOpen={isMockLocation}
                    msg={`Location morphing is cheating. ${checkInText} not allowed`}
                    countToOpenModal={countToOpenModal}
                    url={match?.params?.lead_id !== undefined ? `v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}/${match?.params?.lead_id}` :`v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}
                />
            }

            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            {openCheckIn ?
                                <>
                                    <div className="popup-box">
                                        <div className="box">
                                            {!versionCheck('3.0.0') ?
                                                <DistanceCalculator
                                                    isMapShow={true}
                                                    calculateDistance={markAttendance}
                                                    moduleType={projectName}
                                                    checkInText={checkInText}
                                                    activityId={saveActivityRes?.data?.id !== undefined ? saveActivityRes?.data?.id : null}
                                                    leadId={match?.params?.lead_id !== undefined ? match?.params?.lead_id : ''}
                                                    documentUploadUrlPublic={documentUploadUrlPublic}
                                                    documentUrlDataPublic={documentUrlDataPublic}
                                                    attendanceResponse={attendance}
                                                    module_name={"is_opportunity"}
                                                    accountId={match?.params?.account_id}
                                                    opportunity_id={match?.params?.opportunity_id}
                                                    allowCheckOutOnMissingMeeting={true}
                                                    showTaggedAlong={true}
                                                    taggedAlongList={senior}
                                                    hideCheckButton={hideCheckIn}
                                                    projectType={projectType}
                                                    deviceIdCheck={true}
                                                /> :
                                                currentUserLocation?.current?.lat &&
                                                <DistanceCalculatorV2
                                                    isMapShow={true}
                                                    calculateDistance={markAttendance}
                                                    moduleType={projectName}
                                                    checkInText={checkInText}
                                                    activityId={saveActivityRes?.data?.id !== undefined ? saveActivityRes?.data?.id : null}
                                                    leadId={match?.params?.lead_id !== undefined ? match?.params?.lead_id : ''}
                                                    documentUploadUrlPublic={documentUploadUrlPublic}
                                                    documentUrlDataPublic={documentUrlDataPublic}
                                                    attendanceResponse={attendance}
                                                    module_name={"is_opportunity"}
                                                    accountId={match?.params?.account_id}
                                                    opportunity_id={match?.params?.opportunity_id}
                                                    allowCheckOutOnMissingMeeting={true}
                                                    showTaggedAlong={true}
                                                    taggedAlongList={senior}
                                                    hideCheckButton={hideCheckIn}
                                                    projectType={projectType}
                                                    deviceIdCheck={true}
                                                />}

                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    {versionCheck('3.0.0') &&
                                                        <div
                                                            className="d-flex align-items-center justify-content-between com-sub-heading" style={{position: "relative", left:"88%"}}>
                                                            {isLocationFetching ? "Location fetching..." : ""}
                                                            {locationStatus !== "granted" && !currentUserLocation?.current?.lat &&
                                                                <h1 className="h3 mb-0 text-black-100">
                                                                    <span
                                                                        style={{color: "green"}}
                                                                        className="ml-5"> You've denied GPS/permission, please allow it and then relaunch the
                                                                application</span>
                                                                </h1>
                                                            }
                                                            <button className="btn btn-primary mr-4" onClick={(e) => {
                                                                refreshUserLocation(e)
                                                            }}><i className="bi bi-arrow-clockwise f-20px"></i></button>
                                                        </div>
                                                    }
                                                    <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                        <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                                handleInput('next_activity_type_id', e.target.value, e)
                                                                setActivityId(e.target.value)
                                                                setStageId('')
                                                                handleResetMetaData()
                                                            }} required={true}>
                                                            <option value="">Select Stages
                                                            </option>
                                                            {leadOpportunityActivity?.data !== undefined &&
                                                                leadOpportunityActivity?.data.length > 0 && leadOpportunityActivity?.data.map((val) => {
                                                                    return (
                                                                        <option
                                                                            value={val?.id}>{val.name}</option>
                                                                    )
                                                                })}
                                                        </select>
                                                        <label className="large-label float-lb">
                                                            Stages <i className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                    {leadOpportunityActivity?.stages !== undefined && leadOpportunityActivity?.stages[activityId] !== undefined &&
                                                        leadOpportunityActivity?.stages[activityId] !== null && Object.keys(leadOpportunityActivity?.stages).length > 0 &&
                                                        <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                            <select
                                                                className="form-control form-control-user"
                                                                onChange={(e) => {
                                                                    handleInput('sub_stage_id', e.target.value, e)
                                                                    setStageId(e.target.value)
                                                                }} required={true}>
                                                                <option value="">Select Sub Stage
                                                                </option>
                                                                {leadOpportunityActivity?.stages[activityId].length > 0 && leadOpportunityActivity?.stages[activityId].map((val) => {
                                                                    return (
                                                                        <option
                                                                            value={val?.id}>{val.name}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Sub Stages <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                    }

                                                    <Type
                                                        documentUrlDataPublic={documentUrlDataPublic}
                                                        documentUploadUrlPublic={documentUploadUrlPublic}
                                                        handleInput={handleInput}
                                                        stagesId={stageId}
                                                        formData={leadOpportunityActivity}
                                                        LastLeadOpportunityActivity={LastLeadOpportunityActivity}
                                                        inputList={inputList}
                                                        opportunityDetails={opportunityDetails}
                                                        activityId={activityId}
                                                        senior={senior}
                                                        selectedTaggedAlongResponse={selectedTaggedAlongResponse}
                                                        setTaggedAlonedReportee={setTaggedAlonedReportee}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-4 d-flex">
                                            <button className="btn btn-primary btn-user btn-block submit-btn" disabled={disableSubmit}>
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </>
                            }
                            {/*Heading*/}
                            {/* <div className="d-sm-flex align-items-center justify-content-between mb-4d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-black-100">Activity</h1>
                            </div> */}

                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default V2OpportunityActivity